export default function ReviewRenderer({ jsonSchema, questionAnswers }) {

    const getSingleFieldValue = (question, field) => {

        // grouped structure
        if (questionAnswers[question.code]?.[field.code] !== undefined)
            return questionAnswers[question.code][field.code];

        // flat structure (your current)
        if (questionAnswers[field.code] !== undefined)
            return questionAnswers[field.code];

        return "-";
    };

    const formatValue = (value) => {
        if (value === undefined || value === null || value === "")
            return "-";

        // Multi-select array → comma separated
        if (Array.isArray(value)) {
            return value.length ? value.join(", ") : "-";
        }

        // Textarea with line breaks
        if (typeof value === "string" && value.includes("\n")) {
            return value; // we will preserve line breaks via CSS
        }

        return value;
    };


    const renderSingleAnswer = (question) => {
        return (
            <div className="space-y-4">
                {question.fields.map((field) => (
                    <div
                        key={field.code}
                        className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-1 md:gap-4 items-start"
                    >
                        <span className="font-medium text-[#0a2540]">
                        {field.name}
                    </span>

                        <span
                            className="text-left md:text-left break-words mt-1 md:mt-0 font-semibold whitespace-pre-line">
                        {formatValue(getSingleFieldValue(question, field))}
                    </span>
                    </div>
                ))}
            </div>
        );
    };

    const renderMultipleAnswer = (question) => {
        const answers = questionAnswers[question.code];
        if (!answers || !answers.length) return null;

        return answers.map((item, index) => (
            <div
                key={item.id || index}
                className="border rounded p-3 mb-3"
            >
                <div className="font-semibold mb-3">
                    {question.multipleTag} {index + 1}
                </div>

                <div className="space-y-3">
                    {question.fields.map((field) => (
                        <div
                            key={field.code}
                            className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-1 md:gap-4 items-start"
                        >
                            <span className="font-medium text-[#0a2540] break-words">
                            {field.name}
                        </span>


                            <span className="text-left md:text-left mt-1 md:mt-0 break-words font-semibold">
                            {item[field.code] ?? "-"}
                        </span>
                        </div>
                    ))}
                </div>
            </div>
        ));
    };


    return (
        <div>
            {jsonSchema.questions.map((question) => {
                const hasAnswer = questionAnswers[question.code];
                if (!hasAnswer) return null;

                return (
                    <div
                        key={question.code}
                        className="border border-gray-300 rounded-lg p-4 mb-4"
                    >
                        <h3 className="text-lg font-semibold mb-3">
                            {question.question}
                        </h3>

                        {question.multiple
                            ? renderMultipleAnswer(question)
                            : renderSingleAnswer(question)}
                    </div>
                );
            })}
        </div>
    );
}
